import { PoundIcon } from './PoundIcon';

/**
 * author: Austin Andrews
 * id 9344AA1D-FF8B-432F-A314-C416DFA37F12
 * name pound
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pound.svg
 * tags
 */
export const HashtagIcon = PoundIcon;
export default HashtagIcon